export interface IUser {
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  department?: string;
  id: number;
}

export interface ICurrentUser extends IUser {
  isAdmin: boolean;
  roles: RoleCode[];
}

export interface IGenericUser {
  name: string;
  email: string;
}

export enum RoleCode {
  Admins = "ADMINS",
  Communications = "COMMUNICATIONS",
  Legals = "LEGALES",
  KnowledgeTeam = "KNOWLEDGE_TEAM",  
  KnowledgeBoard = "KNOWLEDGE_BOARD",
}
